<template>
    <div class="form-single">
        <div class="content-caption dashed">
            <span>附件信息</span>
            <span class="input-tip error" style="font-size: 12px;" v-if="edit">提示:最多上传5个附件，每个附件大小不可超过5M</span>
        </div>
        <div class="form-value">
            <swb-file-upload v-if="edit" fileGroup="image-goods" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="false"></swb-file-upload>
            <ul class="file-area clearfix" v-if="fileList.length > 0">
                <li class="file-content fl clearfix" v-for="(file, index) in fileList">
                    <swb-file-item :trackKey="index" :fileName="file.fileName" :fileUuid="file.fileUuid" :fileBrowseUrl="file.fileBrowseUrl" :fileDownloadUrl="file.fileDownLoadUrl" :fileMd5="file.fileMd5" :deletable="edit" :onDelete="deleteFile"></swb-file-item>
                </li>
            </ul>
            <div v-if="!edit && fileList.length <= 0" class="font14 align-center font-gray2" style="margin-top: 20px;">无附件信息...</div>
        </div>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import goodsDelivApi from '../../api/goodsDeliv';
    //
    import SwbFileUpload from '../ctrl/FileUpload';
    Vue.regist(SwbFileUpload);
    import SwbFileItem from '../ctrl/FileItem';
    Vue.regist(SwbFileItem);

    export default {
        name: 'swb-recv-file-edit',
        desc: '收货附件',
        props: ['id', 'edit'],
        data: function () {
            return {
                fileList: []
            }
        },
        created: function () {
            if(!Utils.isNoB(this.id)) {
                this.getGoodsRecvFileListByVoucherId();
            }
        },
        methods: {
            getGoodsRecvFileListByVoucherId: function () {
                let self = this;
                let postData = {};
                postData.voucherId = self.id;
                goodsDelivApi.getGoodsRecvFileListByVoucherId(postData, function (result) {
                    if(result.type == "info") {
                        self.fileList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //上传前（进行验证检查）处理，可以返回false取消上传
            onBeforeUpload: function (fileItems, uploader) {
                let fileList = this.fileList || [];
                if(fileList.length > 4) {
                    MsgBox.warning("最多上传5个附件");
                    return false;
                }
                if(fileItems.length === 0) {
                    MsgBox.warning('喂，你还没选择要上传的文件吧');
                    return false;
                }
            },
            //上传进度处理
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            //上传完毕处理（根据result.type判断是否有误）
            onUploadDone: function (result) {
                let self = this;
                let fileList = self.fileList || [];
                if(fileList.length > 4) {
                    MsgBox.warning("最多上传5张附件");
                    return false;
                }
                if(result.type === 'info') {
                    let files = result.data.files || [];
                    let file = files[0];
                    let recvFile = {};
                    recvFile.fileName = file.fileName;
                    recvFile.fileUuid = file.fileUuid;
                    recvFile.fileBrowseUrl = file.fileBrowseUrl;
                    recvFile.fileDownLoadUrl = file.fileDownloadUrl;
                    recvFile.fileMd5 = file.fileMd5;
                    fileList.push(recvFile);
                    self.fileList = Utils.merge([], fileList);
                } else {
                    MsgBox.warning(result.message);
                }
            },
            deleteFile: function (index) {
                this.fileList.removeAt(index.trackKey);
                return false;
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                let fileList = self.fileList || [];
                result.data = fileList;
                result.type = "info";
                return result;
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/order/GoodsRecvFileList.vue